import * as React from "react";

interface IProps {
    className?: string
}

export class PanelDashed extends React.Component<IProps> {
    public render() {
        return (
            <div className={`panel-dashed ${this.props.className}`}>
                <div className="panel-dashed-inner">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PanelDashed.tsx